const OI_CHANGE_TIME_PERIOD_MAPPING = {
  LAST_ONE_HOUR: '1h',
  LAST_TWO_HOURS: '2h',
  LAST_FOUR_HOURS: '4h',
  LAST_EIGHT_HOURS: '8h',
  LAST_TWELVE_HOURS: '12h',
  LAST_TWENTY_FOUR_HOURS: '24h',
};

const TAKER_ACTIVITY_TIME_PERIOD = {
  '1H': '1h',
  '2H': '2h',
  '4H': '4h',
  '8H': '8h',
  '12H': '12h',
  '24H': '24h',
};

/**
 * Used as an identifier for points keys, series and data mappings.
 */
const TAKER_ACTIVITY_CONTRACT_TYPE_MAPPING = {
  CALL_BUY: 'callBuy',
  CALL_SELL: 'callSell',
  PUT_BUY: 'putBuy',
  PUT_SELL: 'putSell',
} as const;

export {
  OI_CHANGE_TIME_PERIOD_MAPPING,
  TAKER_ACTIVITY_CONTRACT_TYPE_MAPPING,
  TAKER_ACTIVITY_TIME_PERIOD,
};
